import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open() {
    const selector = this.element.dataset.attachmentsTarget
    if (!selector) return

    const mdFileDrop = document.querySelector(`.md-file-drop[data-target-field='${selector}']`)
    if (mdFileDrop) {
      const isHidden = mdFileDrop.classList.contains('hidden') ||
        mdFileDrop.classList.contains('tw-hidden') ||
        mdFileDrop.hasAttribute('hidden') ||
        mdFileDrop.style.display === 'none'

      if (isHidden) {
        mdFileDrop.classList.remove('hidden')
        mdFileDrop.classList.remove('tw-hidden')
        mdFileDrop.removeAttribute('hidden')
        if (mdFileDrop.style.display === 'none') mdFileDrop.style.display = ''
        mdFileDrop.scrollIntoView({ block: 'nearest' })
      } else {
        mdFileDrop.classList.add('hidden')
      }
      return
    }

    const target = document.querySelector(selector)
    if (target) target.click()
  }
}
